import { PvDatePicker } from 'components/form/PvDatePicker';
import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-redux-i18n';
import { Flex, Label } from 'rebass';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { space, width } from 'styled-system';
import { PvBox, PvButton } from 'styles/CustomComponents';
import moment from 'moment';
import { PvSelect } from 'components/form/PvSelect';
import { isDayBlockedLessonEdit} from './isDayBlocked';
import { shouldSelectExamClass } from '../../util/SearchUtil';

const PvSearchBtn = styled(PvButton)`
  ${space}
  ${width}
`;

const examClassesToDropdown = (examClasses) => {
  if (!examClasses)
    return [];
  return examClasses.map(ec => {
    return {value: ec, label: ec};
  });
};

class TheoryLessonsSearch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      datePickerOpen: false,
      executeSearch: true
    };
    const { searchTerms, examClasses, updateSearchTerms } = this.props;
    
    if (shouldSelectExamClass(searchTerms, examClasses)) {
      updateSearchTerms({ examClass: examClasses[0] });
    }
  }

  componentDidUpdate(prevProps) {
    // execute search automatically after first load or if lessonType changes from theory to training
    if (this.state.executeSearch || this.props.lessonType !== prevProps.lessonType) {
      this.setState({ executeSearch: false });
      this.props.searchFn(this.props.searchTerms);
    }
  }

  // Force moment locale refresh for the datepicker
  componentWillUpdate(props) {
    if (!!props.searchTerms && !!props.searchTerms.lessonDate)
      props.searchTerms.lessonDate.locale(moment.locale());
  }

  render() {

    const {
      examClasses,
      loading,
      searchFn,
      searchTerms,
      updateSearchTerms
    } = this.props;

    const {
      datePickerOpen
    } = this.state;

    return (
      <PvBox my={3}>
        <Flex flexWrap='wrap' alignItems='flex-end'>
          <PvBox display='inline-block' px={2} pb={3}>
            <Label mb={2}>
              <Translate value='search.lesson_date' />
            </Label>
            <PvDatePicker
              date={searchTerms.lessonDate}
              onDateChangeFn={(date) => updateSearchTerms({lessonDate: date})}
              focused={datePickerOpen}
              onFocusChangeFn={({focused}) => this.setState({datePickerOpen: focused})}
              showDefaultInputIcon={false}
              isDayBlocked={isDayBlockedLessonEdit}
            />
          </PvBox>
          <PvBox minWidth='19em' display='inline-block' px={2} pb={3}>
            <Label mb={2}>
              <Translate value='search.exam_class' />
            </Label>
            <PvSelect
              placeholder=''
              options={examClassesToDropdown(examClasses)}
              value={{value: searchTerms.examClass, label: searchTerms.examClass}}
              onChange={(option) => updateSearchTerms({examClass: option.value})}
              isLoading={loading}
            />
          </PvBox>
          <PvBox display='inline-block' px={2} pb={3}>
            <PvSearchBtn
              onClick={() => searchFn(searchTerms)} px={3} width='100%'
              disabled={!searchTerms.examClass || searchTerms.examClass === ''}>
              <Translate value='action.search' />
            </PvSearchBtn>
          </PvBox>
        </Flex>
      </PvBox>
    );
  }
}

TheoryLessonsSearch.propTypes = {
  loading: PropTypes.bool,
  lessonType: PropTypes.string,
  searchFn: PropTypes.func,
  searchTerms: PropTypes.object,
  updateSearchTerms: PropTypes.func
};

const mapStateToProps = (state) => {
  return {
    examClasses: state.userState.courseData
      ? state.userState.courseData.examClasses
      : [],
    loading: state.general.loading,
  };
};

export default connect(
  mapStateToProps
)(TheoryLessonsSearch);



// WEBPACK FOOTER //
// ./src/containers/search/TheoryLessonsSearch.jsx